<script>
  import { marked } from "marked";
  import { renderSanitizedHTML } from "../utilities/components/markdown";
  import { isExternalUrl, correctedUrl } from "../utilities/url-helpers";
  import { textToId } from "../utilities/dom-helpers";

  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { page } from "$app/stores";

  export let input;
  export let id;
  export let element = "div";
  let clazz = "";
  export { clazz as class };
  let isExternal = false;

  let externalLinks = {};
  let origin;

  $: origin = $page?.url?.origin;

  marked.use({
    extensions: [
      {
        name: "strong",
        renderer(token) {
          return `<span class="font-bold">${token.text}</span>`;
        }
      },
      {
        name: "link",
        renderer(token) {
          let href = token.href;
          let text = token.text;
          isExternal = isExternalUrl(href, origin);
          let linkToRender = correctedUrl(href);

          const linkId = id ? `markdown-link-${id}` : `markdown-link-${textToId(text)}`;
          if (isExternal) {
            externalLinks[linkId] = text;

            return `<a id="${linkId}" href="${linkToRender}" target="_blank" rel="noopener noreferrer" data-sveltekit-reload class="markdown-external link outline-2 outline-offset-4 focus-visible:outline-dashed cursor-pointer relative inline text-black outline-black focus-visible:border-black hover:before:w-[0px] hover:text-cobalt-blue"><span><span class=""><span class="underline">${text}</span> <span class="inline whitespace-nowrap "><span class="inline-block"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" aria-hidden="true" class="xl:w-6 xl:h-6 inline" width="16" height="16"><path fill="currentColor" fill-rule="evenodd" d="m11.177 5.362.513 4.26 1.967-.2-.854-7.1-7.1-.854-.2 1.967 4.26.512-8.273 8.274 1.414 1.414z" clip-rule="evenodd"></path></svg></span></span></span></span> <span class="sr-only">(Opens in a new tab)</span></a>`;
          } else {
            return `<a id="${linkId}" href="${linkToRender}" data-sveltekit-reload class="markdown-internal link outline-2 outline-offset-4 focus-visible:outline-dashed cursor-pointer relative inline text-black outline-black focus-visible:border-black hover:before:w-[0px] hover:text-cobalt-blue"><span><span class=""><span class="underline">${text}</span></span></span></a>`;
          }
        }
      }
    ]
  });

  let htmlText = renderSanitizedHTML(input);
</script>

{#if input}
  <svelte:element this={element} class="{clazz} whitespace-pre-wrap" {id}>
    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
    {@html htmlText}
  </svelte:element>
{/if}
